import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Fade } from "@mui/material";

const AlertMessage = ({ message, type, show, duration = 2500 }) => {
   const [showAlert, setShowAlert] = useState(show);

   useEffect(() => {
      if (show) {
         setShowAlert(true);
         const timer = setTimeout(() => {
            setShowAlert(false);
         }, duration);
         return () => clearTimeout(timer);
      } else {
         setShowAlert(false);
      }
   }, [show]);

   const alertStyle = {
      position: "fixed",
      top: "10%",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1300,
      width: "80%",
      maxWidth: "max-content",
   };

   return (
      <>
         <Fade in={showAlert} timeout={{ enter: 500, exit: 500 }}>
            <Box sx={alertStyle}>
               <Alert
                  // icon={<CheckIcon fontSize="inherit" />}
                  severity={type}
                  sx={{ textAlign: "center" }}
               >
                  {message}
               </Alert>
            </Box>
         </Fade>
      </>
   );
};

export default AlertMessage;
